/**
 * Created by DSadler on 02/05/2017.
 */
import * as actions from './actions';
import initialState from './initialState.json'

export function templates (state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_TEMPLATE:
      return state;
    case actions.UPDATE_TEMPLATE:
      return state;
    case actions.DELETE_TEMPLATE:
      return state;
    case actions.SET_TEMPLATES:
      return state;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/state/templates/reducers.js